export default function formatContentFulEntries(loc) {
  if (loc) {
    return loc.edges.map((l) => l.node)
  }
  return []
}
